import {getRequest, postRequest} from "../routes/Routes";
import {sessionService} from 'redux-react-session';

export const loadCategories = async () => {
    let categories = [];
    await getRequest('/api/categories').then(response => {
        if (response.status === 200) {
            if (response.data.error) {
                this.props.alert.error(response.data.message);
            } else {
                categories = response.data.categories;
            }
        } else {
            this.props.alert.error(response.data.message);
        }
    });
    return categories;
};

export const addProductToCart = async (product) => {
    let cart = [];
    sessionService.loadSession().then((session) => {
        cart = session.cart;
        let productIndex = cart.findIndex(function (item) {
            return (item.id === product.id);
        });
        if (productIndex >= 0) {
            cart[productIndex] = product;
        } else {
            cart.push(product);
        }
        sessionService.saveSession({cart: cart});
    }).catch(() => {
        cart.push(product);
        sessionService.saveSession({cart: cart});
    })
};

export const getCartProducts = async () => {
    return await sessionService.loadSession().then((session) => {
        return session.cart;
    }).catch(() => {
        return [];
    });
};

export const updateCart = async (cart) => {
    sessionService.saveSession({cart: cart});
};

export const loadProduct = async (id) => {
    let product = {};
    await getRequest('/api/products/' + id).then(response => {
        if (response.status === 200) {
            if (response.data.error) {
                this.props.alert.error(response.data.message);
            } else {
                product = response.data.product;
            }
        } else {
            this.props.alert.error(response.data.message);
        }
    });
    return product;
};

export const addToCartFormSubmit = (event, alert) => {
    let product = {
        id: event.target.id.value,
        name: event.target.name.value,
        stock: event.target.stock.value,
        quantity: event.target.quantity.value,
        price: event.target.price.value
    }
    addProductToCart(product).then(() => {
        alert.success("Successfully Added to Cart");
    }).catch(() => {
        alert.error("An error occurred while adding to cart");
    });
}

export const getServiceCharge = (total) => {
    return 200 > total * (10 / 100) ? 200 : total * (10 / 100);
}